import "./PronunciationButton.css";
// 播放音频函数
const playAudio = (word: string) => {
  const audio = new Audio(
    `https://dict.youdao.com/dictvoice?audio=${encodeURIComponent(word)}&type=2`
  );
  audio.play();
};

/**
 * "播放发音"按钮的属性接口定义
 */
interface PronunciationButtonProps {
  word: string;
}

/**
 * "播放发音"按钮。
 * @param props 包含需要发音的单词
 * @returns 发音按钮组件
 */
export const PronunciationButton = ({ word }: PronunciationButtonProps) => {
  return (
    <button className="play-audio-button" onClick={() => playAudio(word)}>
      播放发音
    </button>
  );
};
